import React from 'react';
import FormControlCaption from "../../formComponents/FormControlCaption";
import cl from "./SuggestionBlock.module.css";
import FormInput from "../../formComponents/FormInput";
import {allArtistRoles} from "../../data/Enums";
import FormBlock from "../../formComponents/FormBlock";

const SuggestionBlock = ({initData}) => {
    return (
        <FormBlock title="Заявка" mode="warn">
            <div>
                <FormControlCaption text="Отправитель заявки"/>
                {renderUserField("uid", initData.user_id)}
                {/*{renderUserField("Имя", initData.user_name)}
                    {renderUserField("e-mail", initData.user_email)}*/}
            </div>
            <hr className={cl.userHr}/>
            <FormInput
                controlRef={null}
                label="ФИО автора"
                widthLimit={500}
                initValue={initData?.fio ?? ""}
                readOnly={true}
            />
            <FormInput
                controlRef={null}
                label="Род деятельности автора"
                widthLimit={150}
                initValue={(initData?.role ?? "") !== "" ? (allArtistRoles.find(x => x.id === initData.role)?.name ?? "?") : ""}
                readOnly={true}
            />
        </FormBlock>
    );
};

function renderUserField(label, value) {
    return <p className={cl.userFieldRow}><span className={cl.userFieldLabel}>{label}:</span> <span
        className={cl.userFieldValue}>{value}</span></p>
}

export default SuggestionBlock;